/**
 * Silent API renewal never initiates interaction. Report failure to the
 * session gate so an expired session can offer explicit recovery.
 */
export async function acquireApiTokenSilently(
  acquire: () => Promise<{ accessToken: string }>,
  reportFailure: (failed: boolean) => void
): Promise<string | null> {
  try {
    const result = await acquire();
    reportFailure(!result.accessToken);
    return result.accessToken || null;
  } catch {
    reportFailure(true);
    return null;
  }
}
